
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/microphone-rental",
      function () {
        return require("private-next-pages/microphone-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/microphone-rental"])
      });
    }
  